(function () {
  'use strict';

  var modal = document.querySelector('.cwear-cart-modal');
  if (!modal) return;

  var panel = modal.querySelector('.cwear-cart-modal__panel');
  var backdrop = modal.querySelector('[data-cwear-cart-backdrop]');
  var closeBtn = modal.querySelector('[data-cwear-cart-close]');
  var cartItems = modal.querySelector('[data-cwear-cart-items]');
  var subtotal = modal.querySelector('.cwear-cart-modal__subtotal');
  var footer = modal.querySelector('.cwear-cart-modal__footer');

  var state = {
    isOpen: false,
    previousActiveElement: null,
    debounceTimer: null,
    isLoading: false
  };

  function getFocusable(container) {
    return Array.from(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ));
  }

  function trapFocus(e) {
    var items = getFocusable(panel);
    var first = items[0];
    var last = items[items.length - 1];
    if (e.key !== 'Tab') return;

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function openDrawer() {
    state.previousActiveElement = document.activeElement;
    state.isOpen = true;

    // Compensate scrollbar width to prevent layout shift
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = scrollbarWidth + 'px';
    // Fixed elements don't inherit body padding — compensate header too
    var header = document.querySelector('.cwear-header');
    if (header) header.style.paddingRight = scrollbarWidth + 'px';
    document.body.style.overflow = 'hidden';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    modal.addEventListener('keydown', trapFocus);

    fetchCart();

    var first = getFocusable(panel)[0];
    if (first) setTimeout(function () { first.focus(); }, 50);

    document.dispatchEvent(new CustomEvent('cwear:cart-modal', { detail: { open: true } }));
  }

  function closeDrawer() {
    state.isOpen = false;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    var header = document.querySelector('.cwear-header');
    if (header) header.style.paddingRight = '';
    modal.removeEventListener('keydown', trapFocus);

    if (state.previousActiveElement) {
      state.previousActiveElement.focus();
    }

    document.dispatchEvent(new CustomEvent('cwear:cart-modal', { detail: { open: false } }));
  }

  function fetchCart() {
    state.isLoading = true;

    var sectionId = modal.dataset.sectionId;

    fetch('/?sections=' + sectionId)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        renderCart(data[sectionId]);
        state.isLoading = false;
      })
      .catch(function (err) {
        console.error('Error fetching cart:', err);
        state.isLoading = false;
      });
  }

  /* Renderiza el drawer a partir del HTML real de la sección (Section
     Rendering API), no reconstruyendo el markup a mano en JS — así el
     drawer siempre refleja el Liquid/CSS actual sin quedar desincronizado
     cuando cambia el diseño. */
  function renderCart(sectionHtml) {
    if (!cartItems || !sectionHtml) return;

    // Don't open drawer if already on cart page
    if (window.location.pathname === '/cart') {
      closeDrawer();
      return;
    }

    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var newItems = doc.querySelector('[data-cwear-cart-items]');
    var newSubtotal = doc.querySelector('.cwear-cart-modal__subtotal');
    var newFooter = doc.querySelector('.cwear-cart-modal__footer');

    if (newItems) cartItems.innerHTML = newItems.innerHTML;

    if (subtotal && newSubtotal) {
      subtotal.innerHTML = newSubtotal.innerHTML;
      subtotal.style.display = newSubtotal.style.display;
    }

    if (footer && newFooter) {
      footer.style.display = newFooter.style.display;
    }
  }

  function updateBadges(count) {
    document.querySelectorAll('[data-cwear-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function updateQuantity(id, qty) {
    if (!id) return;

    state.isLoading = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: id,
        quantity: qty
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateBadges(cart.item_count);
        fetchCart();
      })
      .catch(function (err) {
        console.error('Error updating:', err);
        state.isLoading = false;
      });
  }

  function deleteItem(id) {
    updateQuantity(id, 0);
  }

  var BACKUP_KEY = 'cwearCartBackup';

  /* "Comprar solo esto": vacía el carrito dejando únicamente esta
     variante y va directo a /checkout. El resto de los items se
     respalda en localStorage y se restaura solo (ver
     restoreCartBackup) la próxima vez que el cliente vuelve a la
     tienda — complete la compra o la abandone, ese item ya se
     considera fuera del carrito de todos modos. */
  function buyNow(variantId, quantity, btn) {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var backup = cart.items
          .filter(function (item) { return String(item.variant_id) !== String(variantId); })
          .map(function (item) { return { id: item.variant_id, quantity: item.quantity }; });

        try {
          if (backup.length) {
            localStorage.setItem(BACKUP_KEY, JSON.stringify(backup));
          } else {
            localStorage.removeItem(BACKUP_KEY);
          }
        } catch (e) {
          console.error('Error guardando respaldo del carrito:', e);
        }

        return fetch('/cart/clear.js', { method: 'POST' });
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('Error en compra directa:', err);
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Comprar solo esto';
        }
      });
  }

  /* Restaura el respaldo del carrito (si existe) al cargar cualquier
     página — cubre tanto volver de un checkout completado como
     abandonarlo a medias. */
  function restoreCartBackup() {
    var raw;
    try {
      raw = localStorage.getItem(BACKUP_KEY);
    } catch (e) {
      return;
    }
    if (!raw) return;

    var items;
    try {
      items = JSON.parse(raw);
    } catch (e) {
      items = null;
    }

    try {
      localStorage.removeItem(BACKUP_KEY);
    } catch (e) {}

    if (!items || !items.length) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateBadges(cart.item_count);
      })
      .catch(function (err) {
        console.error('Error restaurando respaldo del carrito:', err);
      });
  }

  restoreCartBackup();

  // EVENTS
  // Don't enable trigger if on cart page
  if (window.location.pathname !== '/cart') {
    document.querySelectorAll('[data-cwear-cart-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.isOpen) closeDrawer();
  });

  /* cwear:cart:open — disparado por cwear-pdp-main.js u otros módulos tras un add-to-cart exitoso */
  document.addEventListener('cwear:cart:open', function () {
    openDrawer();
  });

  if (cartItems) {
    cartItems.addEventListener('click', function (e) {

      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      var del = e.target.closest('[data-delete]');
      var buyNowBtn = e.target.closest('[data-buy-now]');

      if (minus || plus) {
        var btn = minus || plus;
        var id = btn.dataset.id;

        var wrapper = btn.closest('.cwear-cart-item');
        var display = wrapper.querySelector('[data-qty-display]');
        var current = parseInt(display.textContent, 10);

        updateQuantity(id, minus ? current - 1 : current + 1);
      }

      if (del) {
        deleteItem(del.dataset.id);
      }

      if (buyNowBtn) {
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = 'Redirigiendo...';
        buyNow(buyNowBtn.dataset.id, parseInt(buyNowBtn.dataset.qty, 10), buyNowBtn);
      }
    });
  }

})();